angular.module('storefrontApp')
    .component('vcProfileForm', {
        templateUrl: "themes/assets/js/common-components/profileForm.tpl.liquid",
        bindings: {
            profileData: '<',
            onSubmit: '&'
        },
        controller: ['storefront.operatorApi', 'loadingIndicatorService', '$q', function (operatorApi, loader, $q) {
            var $ctrl = this;
            $ctrl.loader = loader;
            $ctrl.providers = [];
            $ctrl.organizations = [];
            $ctrl.updateProvider = updateProvider;
            $ctrl.submit = submit;


            $ctrl.$onChanges = function (changes) {
                if (changes.profileData && angular.isObject(changes.profileData.currentValue)) {
                    if (!$ctrl.providers.length) {
                        if ($ctrl.profileData.isImpersonating) {
                            $ctrl.loader.isLoading = true;
                            operatorApi.getProvidersWithOffices().$promise
                                .then(function (results) {
                                    $ctrl.providers = results;
                                    populateOrganizations();
                                })
                                .catch(function (error) {
                                    return $q.reject(error);
                                })
                                .finally(function () {
                                    $ctrl.loader.isLoading = false;
                                });
                        }
                    }
                }
                $ctrl.loader.isLoading = false;
            };


            function validate() {
                $ctrl.profileForm.$setSubmitted();
                return !$ctrl.profileForm.$invalid;
            }

            function submit() {
                if (validate()) {
                    $ctrl.onSubmit({ profileData: $ctrl.profileData });
                }
            }

            function updateProvider() {
                $ctrl.profileData.organizationId = null;
                populateOrganizations();
            }


            function populateOrganizations() {
                if ($ctrl.profileData.defaultProviderId) {
                    var provider = _.find($ctrl.providers, function (x) { return x.id === $ctrl.profileData.defaultProviderId });

                    if (provider && provider.organizations && provider.organizations.length > 0) {
                        $ctrl.organizations = provider.organizations;

                        // Don't do this for edits in case there isn't a matching office in the list.
                        // if (provider.organizations.length == 1) {
                        //     $ctrl.profileData.organizationId = provider.organizations[0].id;
                        // }
                    }
                    else {
                        $ctrl.organizations = [];
                    }
                }
            }
        }]
    });
